import { AlertOutlined, CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { GlobalToken, theme, Tree } from 'antd';
import { DataNode } from 'antd/es/tree';

import { RuleMessage, RuleMessageLevel } from '@app/domain-interfaces';

export type EligibilityPanelProps = {
  messages: RuleMessage[];
};

export const EligibilityPanel = ({ messages }: EligibilityPanelProps) => {
  const { token } = theme.useToken();

  // convert data to tree view format
  const treeData = toTree(messages, token);

  return <Tree showIcon showLine selectable={false} treeData={treeData} />;
};

const toTree = (messages: RuleMessage[], token: GlobalToken): DataNode[] => {
  let key = 0;

  const innerToTree = (messages: RuleMessage[] | undefined): DataNode[] | undefined => {
    const tree: DataNode[] = [];
    if (!messages || messages.length === 0) return undefined;

    // if messages contain links, render them as links
    messages.forEach((message) => {
      tree.push({
        title: (
          <span
            style={{ userSelect: 'text' }} // override the antd style of 'user-select: none' so that users can select the text and copy it
            dangerouslySetInnerHTML={{
              __html: message.text?.replace(/(https?:\/\/)([^ ]+)/g, '<a target="_blank" href="$&">$2</a>'),
            }}
          ></span>
        ),
        key: ++key,
        icon: getIcon(message.level, token),
        children: innerToTree(message.messages),
      });
    });

    return tree;
  };

  return innerToTree(messages) || [];
};

const getIcon = (level: RuleMessageLevel, token: GlobalToken) => {
  switch (level) {
    case RuleMessageLevel.Error:
      return <AlertOutlined style={{ color: token.colorError }} />;
    case RuleMessageLevel.Warning:
      return <WarningOutlined style={{ color: token.colorWarning }} />;
    default:
      return <CheckCircleOutlined style={{ color: token.colorSuccess }} />;
  }
};
